import React from 'react';

import type { GameDto } from '../../api/types';

import { GameCard } from './GameCard';

import './GameList.css';

type GameListProps = {
  games: GameDto[];
  activeTags?: string[];
  onTagClick?: (tag: string) => void;
};

export function GameList({ games, activeTags, onTagClick }: GameListProps) {
  return (
    <div className="game-list">
      {games.map((game) => (
        <GameCard key={game.id} game={game} activeTags={activeTags} onTagClick={onTagClick} />
      ))}
    </div>
  );
}
